<div class="post-item list-event-item">
    <div class="box-content-inner clearfix">
        <div class="list-event-header">
            <span class="event-place">
                <fa-icon [icon]="['fas', 'globe-americas']" style="font-size: 1.4rem; margin-right: 10px;"></fa-icon>
                <span *ngIf="veranstaltungsort != null; else nichtAngegeben">{{ veranstaltungsort }}</span>
                <ng-template #nichtAngegeben>N/A</ng-template>
            </span>
            <span class="event-date">
                <fa-icon [icon]="['fas', 'calendar']" style="margin-right: 10px;"></fa-icon>
                <span>{{ kursItem.datum }}</span>
            </span>
            <div class="view-details">
                <a routerLink="/event/{{kursItem.id}}" class="lightBtn">Details →</a>
            </div>
        </div>
        <h5 class="event-title">
            <a routerLink="/event/{{kursItem.id}}">
                <span [ngClass]="kursFarbe">{{ titel(kursItem.typ!) }}</span>
            </a>
        </h5>
        <p class="beschreibung"> {{ kursBeschreibung }}</p>
        <span class="label" [ngClass]="style">{{ verfuegbarkeit }}</span>
    </div> <!-- /.box-content-inner -->
</div> <!-- /.list-event-item -->
